// The catalogs a price splits over (TD-075), on the Prices tab: what each is called, and the label rules the
// server applies to a rename (TD-099), so the modal shows what it would refuse before anything is sent.
import type { Catalog } from "../services/pricingService";
import { ENTITY_CONFIG } from "@/core/entityConfig";
import type { CatalogItem } from "../types";

const contractWord = ENTITY_CONFIG.contract.label.toLowerCase();
const expenseWord = ENTITY_CONFIG.expense.label.toLowerCase();

export const LABEL_MAX = 80;

export const CATALOG_WORDS: Record<Catalog, { label: string; plural: string; inUse: string }> = {
  "service-lines": {
    label: ENTITY_CONFIG.serviceLine.label,
    plural: ENTITY_CONFIG.serviceLine.plural,
    inUse: `A listino, a ${contractWord}, an ${expenseWord} or the books use it, so it stays. Rename it instead.`,
  },
  "work-types": {
    label: ENTITY_CONFIG.workType.label,
    plural: ENTITY_CONFIG.workType.plural,
    inUse: `A service line’s split, a ${contractWord}, who does what or the books use it, so it stays. Rename it instead.`,
  },
};

export interface LabelCheck {
  label: string;
  error: string | null;
  blocked: boolean;
}

/** A row of any of the three catalogs a rename checks: a work type, a service line, an expense category. */
export type NamedRow = Pick<CatalogItem, "id" | "label">;

/** A new label for `row`, checked as the server checks it for all three catalogs: required, at most 80 characters, and
 * no other row's label in any case. `noun` names the row in the refusal ("work type"). Unchanged blocks Save quietly. */
export function labelCheck(noun: string, rows: NamedRow[], row: NamedRow, typed: string): LabelCheck {
  const label = typed.trim();
  const clash = rows.some((r) => r.id !== row.id && r.label.toLowerCase() === label.toLowerCase());
  const error = !label ? "Enter a name" : label.length > LABEL_MAX ? `At most ${LABEL_MAX} characters` : clash ? `A ${noun} with that name exists.` : null;
  return { label, error, blocked: error !== null || label === row.label };
}
